<div [formGroup]="formGroup" *ngIf="controlName">
  <mat-label
    [class.text-danger]="
      formGroup.get(controlName)?.hasError('required') &&
      formGroup.get(controlName)?.touched
    "
    *ngIf="label"
    >{{ required ? "*" + label : label }}</mat-label
  >
  <mat-form-field appearance="outline" class="w-full">
    <mat-select
      [multiple]="multiple"
      [disabled]="isDisabled"
      [placeholder]="placeholder"
      (selectionChange)="onOptionSelected($event)"
      [required]="required"
      [formControlName]="controlName"
      (openedChange)="onDropdownClosed($event)"
      (focus)="onFocus()"
    >
      <mat-select-trigger *ngIf="variant === dropdownVariant.BLUE_SHADED">
        <span class="flex flex-row gap-2" *ngIf="multiple">
          <ng-container *ngFor="let selectedItem of selectedOptions">
            <div class="text-[#1e98d7] bg-[#cae4f6] text-xs py-1 px-3 w-min">
              {{ selectedItem }}
            </div>
          </ng-container>
        </span>
      </mat-select-trigger>
      <ng-container *ngFor="let option of options$ | async">
        <mat-option
          *ngIf="option?.id !== undefined || option?.Id !== undefined; else stringTempl"
          [value]="option.id || option.Id"
          [disabled]="option?.disabled || isSelectionDisabled"
          [matTooltip]="option?.disabled ? option?.tooltip : ''"
          [ngClass]="{ 'custom-disabled-option':  isSelectionDisabled }"
        >
          {{ option.name ? option.name : option.Value }}
        </mat-option>
        <ng-template #stringTempl>
          <mat-option [disabled]="option?.disabled || isSelectionDisabled" [value]="option"
          [ngClass]="{ 'custom-disabled-option': isSelectionDisabled }">
            {{ option }}
          </mat-option>
        </ng-template>
      </ng-container>
    </mat-select>
    <mat-error *ngIf="showRequired">Required</mat-error>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  </mat-form-field>
</div>

<mat-label *ngIf="label && isLabelOutside">{{ required ? "*" + label : label }}</mat-label>
<mat-form-field appearance="outline" *ngIf="!controlName" class="w-full">
  <mat-label *ngIf="label && !isLabelOutside">{{ required ? "*" + label : label }}</mat-label>
  <mat-select
    [multiple]="multiple"
    [placeholder]="placeholder"
    (selectionChange)="onOptionSelected($event)"
    [required]="required"
    [disabled]="isDisabled"
    [(ngModel)]="model"
    (openedChange)="onDropdownClosed($event)"
    (focus)="onFocus()"
  >
    <mat-select-trigger>
      {{getSelectedValuesDisplay()}}
    </mat-select-trigger>
    <ng-container *ngIf="displayAllOptionForMultiSelect && this.options.length > 1">
      <mat-checkbox class="mat-option" [checked]="isChecked()" (click)="$event.stopPropagation()"
        [disabled]="isSelectionDisabled" [disableRipple]="true"
        (change)="toggleSelection($event)">
        All
      </mat-checkbox>
    </ng-container>
    <ng-container *ngFor="let option of options$ | async">
      <mat-option *ngIf="option?.id !== undefined ; else stringTempl" [value]="option.id"
        [ngClass]="{ 'custom-disabled-option':  isSelectionDisabled }" [disabled]="option?.disabled || isSelectionDisabled"
        [matTooltip]="option?.disabled ? option?.tooltip : ''"
        (click)="$event.stopPropagation()">
        {{ option.name }}
      </mat-option>
      <ng-template #stringTempl>
        <mat-option [disabled]="option?.disabled || isSelectionDisabled" [value]="option"
          [ngClass]="{ 'custom-disabled-option':  isSelectionDisabled }">
          {{ option }}
        </mat-option>
      </ng-template>
    </ng-container>
  </mat-select>
  <mat-error *ngIf="showRequired">Required</mat-error>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
